<template>
  <div class="iq-card" v-if="questionList.length" :key="refreshComponent">
    <div style="width: 100%;" class="row header-title questionRow m-0 p-0">
      <div class="row questionBox w-100 built-form-scroll">
        <div class="col-12">
          <div>
            <div class="pull-right">
              <!-- View Switcher Button Added -->
              <button type="button" class="btn mr-1 btn-primary" @click="toggleDetailedView" v-if="userData.user_role === 'USERROLE11111' || userData.user_role === 'USERROLE11118'">
                {{ isDetailedView ? 'Switch to Edit View' : 'Switch to Detailed View' }}
              </button>
              <button type="button" class="btn mr-1 btn-primary" @click="goToQuizEdit()" v-if="userData.user_role === 'USERROLE11111' || userData.user_role === 'USERROLE11111'">
                <i class="ri-edit-line mr-1"></i> Edit Quiz
              </button>
              <button type="button" class="btn mr-1 btn-primary" @click="goToQuizQueEdit()" v-if="userData.user_role === 'USERROLE11111' || userData.user_role === 'USERROLE11111'">
                <i class="ri-list-settings-line mr-1"></i> Edit Questions
              </button>
              <button type="button" class="btn mr-1 btn-primary" @click="goToQuizResponses()" v-if="userData.user_role === 'USERROLE11111' || userData.user_role === 'USERROLE11111'">
                <i class="ri-list-settings-line mr-1"></i> View Responses
              </button>
            </div>
          </div>
          <div class="mt-5 info_detail">
            <p v-if="questionObj?.qbk_category == 'sales'">
              {{salesDesc}}
            </p>
            <p v-else>
              {{counselorDesc}}
            </p>
          </div>
        </div>

        <!-- DEFAULT INTERACTIVE INPUT VIEW -->
        <div class="row w-100" v-if="!isDetailedView">
          <div v-for="(qItem, index) in questionList" :key="qItem.qbk_id" class="col-12 col-lg-6 mb-4">
            <div class="que_card border rounded shadow-sm bg-white h-100 position-relative">
              <div class="mb-2">
                <div class="d-flex align-items-start w-100">
                  <span class="font-weight-bolder text-dark font-size-16 mr-2">
                    {{ index + 1 }})
                  </span>
                  <span
                    class="font-weight-bolder text-dark font-size-16 mb-0 pre_questions flex-grow-1"
                    v-html="qItem.question"
                  ></span>
                </div>
              </div>
              <div class="non-mcq-container-edit">
                <div v-if="qItem.is_mcq != 1" class="rounded bg-light mb-3">
                  <input class="form-control" v-model="qItem.answer" placeholder="Enter here ..." @input="emitFormProgress" @blur="saveSingleQuestion(index, qItem)" />
                </div>
                <div v-else-if="qItem.is_mcq == 1" class="optionContainer mb-3">
                  <!-- FOR HANDLING MULTIPLE RESPONSE MCQ -->
                  <template v-if="qItem.correct_answers.includes(',')">
                    <div
                      class="option"
                      v-for="(choice, optionNo) in qItem.answer_choices"
                      :class="{'is-selected': userResponses[qItem.qbk_id] && userResponses[qItem.qbk_id][optionNo]}"
                      :key="optionNo"
                      @click="selectOption(qItem, optionNo); saveSingleQuestion(index, qItem);"
                    >
                      <span class="optionNo">
                        <span class="capitalize mr-2">{{ optionNo }}</span>
                      </span>
                      <span class="vhtmlUlLi optionText" v-html="choice"></span>
                    </div>
                  </template><!-- FOR HANDLING MULTIPLE RESPONSE MCQ -->
                  <template v-else><!-- FOR HANDLING SINGLE RESPONSE MCQ -->
                    <div
                      class="option"
                      v-for="(choice, optionNo) in qItem.answer_choices"
                      :class="{'is-selected': userResponses[qItem.qbk_id] && userResponses[qItem.qbk_id][optionNo]}"
                      :key="optionNo"
                      @click="selectOption(qItem, optionNo); saveSingleQuestion(index, qItem);"
                    >
                      <span class="optionNo">
                        <span class="capitalize mr-2">{{ optionNo }}</span>
                      </span>
                      <span class="vhtmlUlLi optionText" v-html="choice"></span>
                    </div>
                  </template><!-- FOR HANDLING SINGLE RESPONSE MCQ -->
                </div>
                <div>
                  <!-- <button :class="qItem?.answer ? 'btn-success' : 'btn-primary'" class="btn btn-sm save_button" @click="saveSingleQuestion(index, qItem)">
                    Save
                    <b-spinner small class="mr-2" v-if="cvLoadingStatus"></b-spinner>
                  </button> -->
                   <span v-if="isAnswerValid(qItem)" class="ml-auto text-success pull-right">
                    <i class="fa fa-check font-size-14 p-1"></i>
                  </span>
                   <span v-else class="ml-auto pull-right">
                    <i class="fa fa-circle font-size-14 p-1" style="color: #e5252c;"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- NEW DETAILED READ-ONLY CARD VIEW FOR ADMINS & COUNSELORS -->
        <div class="row w-100" v-else>
          <div v-for="(qItem, index) in questionList" :key="'detailed-'+qItem.qbk_id" class="col-12 mb-4">
            <div class="que_card border rounded shadow-sm bg-white h-100 position-relative p-4">
              <div class="mb-3">
                <div class="d-flex align-items-start w-100">
                  <span class="font-weight-bolder text-dark font-size-16 mr-2">
                    {{ index + 1 }})
                  </span>
                  <span
                    class="font-weight-bolder text-dark font-size-16 mb-0 pre_questions flex-grow-1"
                    v-html="qItem.question"
                  ></span>
                </div>
              </div>

              <!-- MCQ Options Rendering with User Response -->
              <template v-if="qItem.is_mcq == 1">
                <div v-if="qItem.answer_choices" class="optionContainer mb-3">
                  <div
                    class="option"
                    v-for="(choice, optionNo) in qItem.answer_choices"
                    :class="{
                      'is-selected': isOptionSelected(qItem, optionNo)
                    }"
                    :key="'det-opt-'+optionNo"
                    style="cursor: default;"
                  >
                    <span class="optionNo">
                      <span class="capitalize mr-2">{{ optionNo }}</span>
                    </span>
                    <span class="vhtmlUlLi optionText" v-html="choice"></span>
                  </div>
                </div>

                <!-- Selected Answer Status Badge for MCQ -->
                <div class="mt-3 pt-2 border-top d-flex align-items-center justify-content-between">
                  <div>
                    <span class="text-muted font-size-14">User Response: </span>
                    <b-badge :style="qItem.answer && qItem.answer !== 'z' ? 'background: #28a745 !important; color: #FFF;' : 'background: #e5252c !important; color: #FFF;'" class="p-2">
                      {{ qItem.answer && qItem.answer !== 'z' ? qItem.answer : 'Z (Skipped/Unanswered)' }}
                    </b-badge>
                  </div>
                </div>
              </template>

              <!-- Non-MCQ Answer Display (Only shows the answer) -->
              <template v-else>
                <div class="mb-3 p-3 bg-light rounded text-dark">
                  <strong>Answer: </strong> {{ qItem.answer && qItem.answer !== 'z' ? qItem.answer : 'No answer provided' }}
                </div>
              </template>

            </div>
          </div>
        </div>

      </div>
    </div>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </div>
</template>

<script>
import { socialvue } from "../../../config/pluginInit.js"
import { QuizBanks } from "../../../FackApi/api/quizBank.js"
import { QuizAnswers } from "../../../FackApi/api/quizAnswers.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import { base64encode } from "nodejs-base64"
import { User } from "../../../FackApi/api/user.js"
import { UserParent } from "../../../FackApi/api/userParent.js"
import Utility from "../../../Utils/utility.js"

export default {
  name: "PreCounsellingv1",
  components: {
  },
  data () {
    return {
      ALLOWEDSTR: /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9 +,\-&$#@*.]*$/,
      questionObj: null,
      refreshComponent: 0,
      appId: null,
      questionList: [],
      userResponses: {},
      cvLoadingStatus: false,
      showToast: false,
      toastTitle: "Student Onboarding Form",
      toastMsg: null,
      toastVariant: "default",
      questionIndex: 0,
      salesDesc: "This data entry form enables the sales team to systematically capture essential student and parental information. It documents comprehensive profiles, including academic backgrounds, household financial status, and professional details such as job roles and company affiliations. This structured approach ensures accurate lead qualification and facilitates personalized engagement for prospective students.",
      counselorDesc: "This comprehensive counseling form serves as a vital tool for advisors to holistically understand each student’s unique profile. It meticulously captures essential details, including personal life journeys, family backgrounds, and financial circumstances. Furthermore, the form documents students' preferred study-abroad destinations, ensuring tailored guidance for their undergraduate academic and career aspirations.",
      totalQuestionCount: 0,
      totalAnswerCount: 0,
      userObj: {
        user_name: null,
        user_dob: null,
        user_mobile_country_code: null,
        user_mobile: null
      },
      parent1Obj: {
        "parent_type": null,
        "parent_name": null,
        "parent_email": null,
        "parent_mobile_country_code": null,
        "parent_mobile": null
      },
      parent2Obj: {
        "parent_type": null,
        "parent_name": null,
        "parent_email": null,
        "parent_mobile": null
      },
      userProfile: {
        education: { class_name: null },
        course_name: null,
        institute_city: null,
        institute_name: null,
        examination_body: null,
        institute_country: null
      },
      gide_user_id: null,
      // Define custom selection limits per qbk_id for multi-select questions here
      multiSelectLimits: {
        "QBKPAQ000016": 3, // Intended Destination
        "QBKPAQ000017": 1 // Interest
      },
      isDetailedView: false
    }
  },
  props: {
    propQuestionObj: {
      default: null,
      type: Object
    }
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  mounted () {
    socialvue.index()
    this.appId = this.propQuestionObj?.app_id || "PRE_COUNSELING_APP_ID"
    this.gide_user_id = this.$route?.params?.user_id ? this.$route.params.user_id : this.propQuestionObj?.user_id

    if (this.propQuestionObj) {
      this.questionObj = this.propQuestionObj
    }
    else {
      // http://localhost:14433/paq/user015bf1d51b874f9891555db06dc841b6
      // Get the Application ID from the route params if not provided via props
      this.appId = this.$route.params.app_id || "PRE_COUNSELING_APP_ID"
      this.questionObj = {
        app_id: this.appId,
        user_id: this.$route.params.user_id || null,
        skill: this.$route.params.skill || "",
        qbk_category: this.$route.params.qbk_category || ""
      }
    }

    // console.log("XXXXX PreCounselling mounted with questionObj:", this.questionObj)
    this.loadAllCounsellingQuestions()
  },
  methods: {
    /**
     * Toggles between standard input form view and detailed read-only card view
     */
    toggleDetailedView () {
      this.isDetailedView = !this.isDetailedView
    },
    /**
     * Checks if a choice option is selected by the user for detailed card view display
     */
    isOptionSelected (qItem, optionNo) {
      if (!qItem.answer) return false
      const selectedOpts = qItem.answer.split(",").map(item => item.trim())
      return selectedOpts.includes(optionNo.toString())
    },
    /**
     * loadAllCounsellingQuestions
     */
    async loadAllCounsellingQuestions () {
      try {
        this.cvLoadingStatus = true
        const payload = {
          gide_user_id: this.questionObj.user_id,
          app_id: this.appId,
          skill: this.questionObj.skill || "",
          qbk_category: this.questionObj.qbk_category || ""
        }
        let response = await QuizBanks.counsellingQuizBankList(this, payload)

        if (response && response.resp_status && response.resp_data?.question_list) {
          const loadedResponses = {}

          this.questionList = response.resp_data.question_list.map(q => {
            const dynamicAprsId = q.aprs_id || `APRS${this.questionObj.user_id}`
            // Handle pre-filled response initialization
            if (q.is_mcq == 1 && q.answer && q.answer.trim() !== "z") {
              const options = q.answer.split(",")
              const optionObj = {}
              options.forEach(opt => {
                optionObj[opt.trim()] = true
              })
              loadedResponses[q.qbk_id] = optionObj
            }
            else {
              const parsedAnswer = q.answer && q.answer.trim() !== "z" ? q.answer : ""
              loadedResponses[q.qbk_id] = {
                answer: parsedAnswer,
                z: parsedAnswer === ""
              }
            }

            let qItem = {
              aprs_id: dynamicAprsId,
              qbk_id: q.qbk_id,
              qbk_category: q.qbk_category,
              question: q.question || "",
              qns_id: q.qns_id || "",
              fallback_guideline: q.fallback_guideline || "",
              answer: q.answer && q.answer.trim() !== "z" ? q.answer : "",
              is_mcq: q.is_mcq,
              answer_choices: q.answer_choices,
              correct_answers: q.correct_answers || ""
            }

            // Create the Object from user's answers if present
            let updatedUserProfileAPI = false
            this.userProfileBuilder(qItem, qItem.qbk_id, qItem.answer, updatedUserProfileAPI)
            return qItem
          })

          // Configure single or dual parent mode when processing the parent1 category
          if (this.questionObj.qbk_category === "parent1") {
            const localToggleId = "LOCAL_PARENT_CONFIG_QBK"
            this.questionList.unshift({
              aprs_id: `APRS${this.questionObj.user_id}`,
              qbk_id: localToggleId,
              qbk_category: "parent1",
              question: "Are you a single parent?",
              is_mcq: 1,
              answer_choices: { a: "Yes", b: "No" },
              answer: "b",
              correct_answers: "b"
            })
            if (!loadedResponses[localToggleId]) {
              loadedResponses[localToggleId] = { b: true }
            }
          }

          this.userResponses = loadedResponses
          if (response.resp_data.question_list.length > 0) {
            const trackingData = response.resp_data.question_list[0]

            this.totalQuestionCount = trackingData.total_questions_count || 0
            this.totalAnswerCount = trackingData.total_answers_count || 0
            this.emitFormProgress()
          }
        }
        else {
          this.toastVariant = "warning"
          this.toastMsg = "Questions not found. Please contact the system administrator on support@gide.ai"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception encountered inside loadAllCounsellingQuestions execution layer:", err)
        this.toastVariant = "danger"
        this.toastMsg = "System error occurred. Please contact the system administrator on support@gide.ai"
        this.showToast = true
      }
      finally {
        this.cvLoadingStatus = false
        this.refreshComponent = Math.random()
      }
    },
    /**
     * Handles Multi-select and Single-select Option Toggle Operations Reactively with selection limits
     */
    selectOption (qItem, selectedOption) {
      try {
        if (!this.userResponses[qItem.qbk_id]) {
          this.$set(this.userResponses, qItem.qbk_id, {})
        }

        let userRespObj = this.userResponses[qItem.qbk_id]
        delete userRespObj["z"]
        delete userRespObj["answer"]

        const isMultiSelectAllowed = qItem.correct_answers && qItem.correct_answers.includes(",")
        if (isMultiSelectAllowed) {
          // Check if option is already selected (so we can allow unselecting)
          if (userRespObj[selectedOption]) {
            this.$delete(userRespObj, selectedOption)
          }
          else {
            // Apply selection limit check based on qbk_id
            const maxAllowed = this.multiSelectLimits[qItem.qbk_id]
            const currentSelectedCount = Object.keys(userRespObj).filter(k => k !== "z" && k !== "answer").length

            if (maxAllowed !== undefined && currentSelectedCount >= maxAllowed) {
              this.toastVariant = "warning"
              this.toastMsg = `You can select a maximum of ${maxAllowed} options for this question.`
              this.showToast = true
              return
            }

            this.$set(userRespObj, selectedOption, true)
          }
        }
        else {
          Object.keys(userRespObj).forEach(key => {
            this.$delete(userRespObj, key)
          })
          this.$set(userRespObj, selectedOption, true)
        }

        if (Object.keys(userRespObj).length === 0) {
          this.$set(userRespObj, "z", true)
          qItem.answer = ""
        }
        else {
          qItem.answer = Object.keys(userRespObj).sort().join(",")
        }

        if (qItem.qbk_id === "LOCAL_PARENT_CONFIG_QBK") {
          const isSingle = selectedOption === "a" && userRespObj["a"]
          this.$emit("emitSingleParentToggle", isSingle)
        }

        this.emitFormProgress()
      }
      catch (err) {
        console.error("Error occurred while handling select choice operations:", err.message)
      }
    },
    /**
     * emitFormProgress
     */
    emitFormProgress () {
      const answeredQuestionCount = this.questionList.filter(qItem =>
        qItem.qbk_id !== "LOCAL_PARENT_CONFIG_QBK" && this.isAnswerValid(qItem)
      ).length

      this.$emit("emitProgressUpdated", {
        total_questions_count: this.totalQuestionCount || this.questionList.length,
        total_answers_count: answeredQuestionCount
      })
    },
    /**
     * isAnswerValid
     */
    isAnswerValid (qItem) {
      const answer = String(qItem.answer || "")
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/g, " ")
        .trim()

      if (answer === "" || answer === "z") return false

      if (["QBKPAQ000003", "QBKPAQ000021", "QBKPAQ000037"].includes(qItem.qbk_id)) {
        return /^\+([1-9]\d{0,5})[- ](\d{6,20})$/.test(answer)
      }

      if (["QBKPAQ000020", "QBKPAQ000036"].includes(qItem.qbk_id)) {
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(answer)
      }

      return this.ALLOWEDSTR.test(answer)
    },
    /**
     * saveSingleQuestion
     */
    async saveSingleQuestion (index, qItem) {
      try {
        this.cvLoadingStatus = true

        let strippedAnswer = qItem.answer ? String(qItem.answer).replace(/<[^>]*>/g, "") : ""
        strippedAnswer = strippedAnswer.replace(/&nbsp;/g, " ").trim()

        if (strippedAnswer === "" || strippedAnswer === "z") {
          return
        }

        if (qItem.is_mcq != 1) {
          this.userResponses[qItem.qbk_id] = {
            answer: qItem.answer,
            z: false
          }
        }

        const payload = {
          aprs_id: qItem.aprs_id ? qItem.aprs_id : `APRS${this.questionObj.user_id}`,
          qbk_id: qItem.qbk_id,
          qbk_category: qItem.qbk_category,
          app_id: this.appId,
          app_category: "PRE_COUNSELLING_CONFIG",
          answer: qItem.answer,
          gide_user_id: this.questionObj.user_id,
          user_response: base64encode(JSON.stringify({ userResponses: this.userResponses }))
        }

        let updatedUserProfileAPI = true
        let resp = await this.userProfileBuilder(qItem, qItem.qbk_id, qItem.answer, updatedUserProfileAPI)
        if (!resp) {
          // In case of validation errors dont process
          return
        }

        let response = await QuizAnswers.quizAnswersAdd(this, payload)
        if (response && response.resp_status) {
          this.emitFormProgress()
          this.$emit("emitUserProfileUpdated", qItem)
        }
        else {
          ApiResponse.responseMessageDisplay(this, response)
        }
      }
      catch (err) {
        console.error("Operational crash inside saveSingleQuestion context blocks:", err.message)
        this.toastVariant = "danger"
        this.toastMsg = "Server error occurred. Please contact the system administrator on support@gide.ai"
        this.showToast = true
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * Update user profile, parents, Education Profile in user, parent user_profile dbs
     */
    async userProfileBuilder (qItem = null, qbkId = null, answer = null, updatedUserProfileAPI = false) {
      // console.log(this.questionObj.tnc_flag, "QBKID=", qbkId, "XXXXX ANSWER=", answer)
      /* As requested by Isha this she should be allowed to edit user & parent details even after TnC submit
      if (this.questionObj.tnc_flag == 1) {
        return true
      }
      */

      const mobileRegex = /^\+([1-9]\d{0,5})[- ](\d{6,20})$/
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      const dobRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/

      /* ********************* Update Student Info ********************* */
      if (qbkId === "QBKPAQ000001" || // Student Name
          qbkId === "QBKPAQ000002" || // Student DoB
          qbkId === "QBKPAQ000003" || // Student Mobile
          qbkId === "QBKPAQ00000X" || // Student Gender
          qbkId === "QBKPAQ000005" || // Student Address
          qbkId === "QBKPAQ000007" || // City
          qbkId === "QBKPAQ000008" || // State
          qbkId === "QBKPAQ000010" // Country
      ) {
        this.userObj.user_name = qbkId === "QBKPAQ000001" ? answer : this.userObj.user_name
        this.userObj.user_dob = qbkId === "QBKPAQ000002" ? answer : this.userObj.user_dob

        if (qbkId === "QBKPAQ000002") {
          if (dobRegex.test(answer)) {
            this.userObj.user_dob = answer
          }
          else {
            if (!updatedUserProfileAPI) return // Dont Show Error on mount
            this.toastMsg = "Invalid Date of Birth"
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }

        if (qbkId === "QBKPAQ000003") {
          const mobileMatch = answer.match(mobileRegex)
          if (mobileMatch) {
            this.userObj.user_mobile_country_code = `+${mobileMatch[1]}`
            this.userObj.user_mobile = mobileMatch[2]
          }
          else {
            if (!updatedUserProfileAPI) return // Dont Show Error on mount
            this.toastMsg = "Invalid Mobile Number"
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }

        // this.userObj.user_gender = qbkId === "QBKPAQ00000X" ? answer : this.userObj.user_gender
        this.userObj.user_city = qbkId === "QBKPAQ000007" ? answer : this.userObj.user_city
        this.userObj.user_state = qbkId === "QBKPAQ000008" ? answer : this.userObj.user_state

        // Fire the userUpdate API only if the updatedUserProfileAPI flag is true
        if (updatedUserProfileAPI) {
          this.userObj.gide_user_id = this.gide_user_id ? this.gide_user_id : this.userData.user_id
          User.userEdit(this, this.userObj)
        }
      }

      /* ********************* Update User Education Profile ********************* */
      if (
        qbkId === "QBKPAQ000007" || // City
        qbkId === "QBKPAQ000008" || // State
        qbkId === "QBKPAQ000010" || // Country
        qbkId === "QBKPAQ000011" || // Grade/class
        qbkId === "QBKPAQ000012" || // School Name
        qbkId === "QBKPAQ000013" // Board
      ) {
        // Build the UserProfile object for the special QBK IDs related to education
        this.userProfile.institute_city = qbkId === "QBKPAQ000007" ? answer : this.userProfile.institute_city
        this.userProfile.institute_state = qbkId === "QBKPAQ000008" ? answer : this.userProfile.institute_state
        this.userProfile.institute_country = qbkId === "QBKPAQ000010" ? answer : this.userProfile.institute_country
        this.userProfile.institute_name = qbkId === "QBKPAQ000012" ? answer : this.userProfile.institute_name

        if (qbkId === "QBKPAQ000011") {
          // loop through the answer choices to find the matching class_name
          for (const [key, value] of Object.entries(qItem.answer_choices)) {
            if (key.includes(answer)) {
              let val = await parseInt(Utility.stripHtmlTags(value))
              this.userProfile.course_name = val
              this.userProfile.education.class_name = val
              break
            }
          }
        }

        if (qbkId === "QBKPAQ000013") {
          // loop through the answer choices to find the matching examination_body
          for (const [key, value] of Object.entries(qItem.answer_choices)) {
            if (key.includes(answer)) {
              let val = await Utility.stripHtmlTags(value)
              this.userProfile.examination_body = val
              break
            }
          }
        }

        // Fire the userUpdate API only if the updatedUserProfileAPI flag is true
        if (updatedUserProfileAPI) {
          // Call the API to update the user profile in the database
          let params = {
            gide_user_id: this.gide_user_id ? this.gide_user_id : this.userData.user_id,
            education: JSON.stringify(this.userProfile)
          }

          User.userProfileAddEdit(this, params)
        }
      }

      /* ********************* Update Parent1 Profile ********************* */
      if (
        qbkId === "QBKPAQ000018" || // Parent1 Relation
        qbkId === "QBKPAQ000019" || // Parent1 Name
        qbkId === "QBKPAQ000020" || // Parent1 email
        qbkId === "QBKPAQ000021" // Parent1 Mobile
      ) {
        // Parent Relation/type
        if (qbkId === "QBKPAQ000018") {
          // loop through the answer choices to find the matching class_name
          for (const [key, value] of Object.entries(qItem.answer_choices)) {
            if (key.includes(answer)) {
              let val = await Utility.stripHtmlTags(value)
              this.parent1Obj.parent_type = val
              break
            }
          }
        }

        this.parent1Obj.parent_name = qbkId === "QBKPAQ000019" ? answer : this.parent1Obj.parent_name

        if (qbkId === "QBKPAQ000020") {
          if (emailRegex.test(answer)) {
            this.parent1Obj.parent_email = answer
            this.parent1Obj.parent_email_verified = 1
          }
          else {
            if (!updatedUserProfileAPI) return // Dont Show Error on mount
            this.toastMsg = "Invalid Email Id"
            this.showToast = true
            return false
          }
        }

        if (qbkId === "QBKPAQ000021") {
          const mobileMatch = answer.match(mobileRegex)
          if (mobileMatch) {
            this.parent1Obj.parent_mobile_country_code = `+${mobileMatch[1]}`
            this.parent1Obj.parent_mobile = mobileMatch[2]
            this.parent1Obj.parent_mobile_verified = 1
          }
          else {
            if (!updatedUserProfileAPI) return // Dont Show Error on mount
            this.toastMsg = "Invalid Mobile Number"
            this.showToast = true
            return false
          }
        }

        // Fire the Parent Add API only if the updatedUserProfileAPI flag is true
        if (updatedUserProfileAPI) {
          this.parent1Obj.gide_user_id = this.gide_user_id ? this.gide_user_id : this.userData.user_id
          this.parent1Obj.addIfMissing = 1
          UserParent.user_parentEdit(this, this.parent1Obj)
        }
      }

      /* ********************* Update Parent2 Profile ********************* */
      if (
        qbkId === "QBKPAQ000034" || // Parent2 Relation
        qbkId === "QBKPAQ000035" || // Parent2 Name
        qbkId === "QBKPAQ000036" || // Parent2 email
        qbkId === "QBKPAQ000037" // Parent2 Mobile
      ) {
        // Parent Relation/type
        if (qbkId === "QBKPAQ000034") {
          // loop through the answer choices to find the matching class_name
          for (const [key, value] of Object.entries(qItem.answer_choices)) {
            if (key.includes(answer)) {
              let val = await Utility.stripHtmlTags(value)
              this.parent2Obj.parent_type = val
              break
            }
          }
        }

        this.parent2Obj.parent_name = qbkId === "QBKPAQ000035" ? answer : this.parent2Obj.parent_name

        if (qbkId === "QBKPAQ000036") {
          if (emailRegex.test(answer)) {
            this.parent2Obj.parent_email = answer
            this.parent2Obj.parent_email_verified = 1
          }
          else {
            if (!updatedUserProfileAPI) return // Dont Show Error on mount
            this.toastMsg = "Invalid Email Id"
            this.showToast = true
            return false
          }
        }

        if (qbkId === "QBKPAQ000037") {
          const mobileMatch = answer.match(mobileRegex)
          if (mobileMatch) {
            this.parent2Obj.parent_mobile_country_code = `+${mobileMatch[1]}`
            this.parent2Obj.parent_mobile = mobileMatch[2]
            this.parent2Obj.parent_mobile_verified = 1
          }
          else {
            if (!updatedUserProfileAPI) return // Dont Show Error on mount
            this.toastMsg = "Invalid Mobile Number"
            this.showToast = true
            return false
          }
        }

        // Fire the Parent Add API only if the updatedUserProfileAPI flag is true
        if (updatedUserProfileAPI) {
          this.parent2Obj.gide_user_id = this.gide_user_id ? this.gide_user_id : this.userData.user_id
          this.parent2Obj.addIfMissing = 1
          UserParent.user_parentEdit(this, this.parent2Obj)
        }
      }

      return true
    },
    /**
     * goTo Quiz Edit
     */
    goToQuizEdit () {
      this.$router.push("/quiz_edit/PRE_COUNSELING_APP_ID")
    },
    /**
     * goTo Quiz Question Edit
     */
    goToQuizQueEdit () {
      this.$router.push("/quizBank_list/PRE_COUNSELING_APP_ID")
    },
    /**
     * goTo Quiz Responses
     */
    goToQuizResponses () {
      let userId = this.gide_user_id ? this.gide_user_id : this.userData.user_id
      let aprsId = `APRS${userId}`
      window.open(`/app_result_analyse/PRE_COUNSELING_APP_ID/${userId}/${aprsId}`)
    }
  }
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Montserrat:400,400i,700");
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700");

body {
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
}
.questionRow {
  background: #fafafa;
  height: 100%;
  border: 1px solid #eef2f4;
}
.header-title .heading {
  font-weight: 700;
  color: #1e2022;
  font-size: 18px;
}
.questionBox {
  width: 100%;
  height: calc(100% - 80px) !important;
  overflow-x: hidden;
  position: relative;
}
.built-form-scroll {
  overflow-y: auto;
  padding: 15px;
}
.full-width-page {
  z-index: 999;
  position: absolute;
  width: 100%;
  display: flex;
  left: 0px;
  top: 0px;
  bottom: 0px;
  padding: 15px !important;
  background-color: #fff;
  align-items: flex-start;
  height: 100%;
}
.native-question-display {
  line-height: 1.6;
  ::v-deep p {
    margin-bottom: 0.5rem;
  }
}
@media (min-width: 992px) {
  .border-right-md {
    border-right: 1px solid #ebedf2 !important;
  }
}
.optionContainer {
  margin-top: 15px;
  .option {
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 8px 15px 8px 50px;
    cursor: pointer;
    border: 1px solid #e9ecef;
    overflow: hidden;
    font-size: 14px;
    min-height: 38px;
    font-weight: 500;
    position: relative;
    display: flex;
    align-items: center;
    color: #495057;
    background-color: #f8f9fa;
    transition: all 0.2s ease-in-out;
    &.is-selected {
      border-color: #e5252c;
      background-color: #fff5f5;
      color: #e5252c;
      .optionNo {
        background-color: #e5252c;
      }
    }
    &:hover {
      background-color: #e9ecef;
    }
  }
}
.optionNo {
  background-color: #6c757d;
  color: #fff;
  left: 0px;
  position: absolute;
  width: 40px;
  height: 100%;
  top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease-in-out;
}
.optionNo span {
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
}
.save_button{
    position: absolute;
    bottom: 15px;
    display: block;
}
.que_card{
    padding: 20px 20px 40px 20px;
}
.pre_questions{
    text-align: left;
}
.info_detail{
    text-align: left;
}
</style>
